// @flow

import * as React from 'react';

import clsx from 'clsx';

import type { User } from '@gandi/authentication';
import { selectPersonal } from '@gandi/redux-sharing';
import { DropDownMenuDivider, DropDownMenuItem } from '@gandi/ui';

import { useAppSelector } from 'src/hooks';

import type { NavigationItems } from '../../types';

import styles from './UserDropDownMenuItem.scss';

export type Props = {
  item: NavigationItems[number],
  userInfo: User,
};

function UserDropDownMenuItem({ item, userInfo }: Props): React.MixedElement {
  const personalOrga = useAppSelector(selectPersonal);
  return (
    <>
      <li role="menuitem">
        <DropDownMenuItem
          icon={item.icon}
          disabled={item.disabled}
          className={clsx(styles.dropdownItem, styles.userInfo)}
        >
          <p>{userInfo.username}</p>
          {personalOrga && <p>{personalOrga.email}</p>}
        </DropDownMenuItem>
      </li>

      <li role="separator">
        <DropDownMenuDivider />
      </li>
    </>
  );
}

export default (React.memo<Props>(
  UserDropDownMenuItem,
): React.ComponentType<Props>);
